import React from "react";
import { useNavigate } from "react-router-dom";
import { extractDate } from "../../Components/Functions/date.fun";
import CustomInput from "../../CustomComponent/custom_input";
import { Formik, Form } from "formik";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import { useState } from "react";
import CustomSelect from "../../CustomComponent/custom_select";
import { HydrobuildRunmachanismInfo } from "../../SchemaInfo/info";
import { runmachanismSchema } from "../../Schemas/Onboard HydroBuild/run_machanism_schema";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import { FcServices } from "react-icons/fc";
import { FcDataConfiguration } from "react-icons/fc";
import { FcFile } from "react-icons/fc";

const tableHead = [
  "Sr.",
  "Farm Name",
  "UID",
  "Tank",
  // "Fert.",
  "Crop Name",
  "Actions",
  "Run Machanism",
  // "Calibration",
];

function Onboardhydrobuildtable({
  hydrobuildData = [],
  currentPage,
  itemsPerPage,
}) {
  const navigate = useNavigate();
  const goToView = (id, isActive) => {
    navigate(`/hydrobuild-logs/${id}`, {
      state: { itemIsActive: isActive },
    });
  };
  const [selectedTankAOption, setSelectedTankAOption] = useState("");
  const [selectedTankBOption, setSelectedTankBOption] = useState("");
  const [selectedPhDownOption, setSelectedPhDownOption] = useState("");
  const [kitId, setkitId] = useState();

  const handelSubmit = (values, actions) => {
    values = { ...values, kitId: kitId };

    performRequest("POST", "/hydrobuild/operations", values)
      .then((res) => {
        if (res.status) {
        } else {
          Toast("error", "Server Error");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
    actions.resetForm();
  };
  const handelCalibrationSubmit = (values) => {
    performRequest("POST", "/hydrobuild/phCal", values.kitId)
      .then((res) => {
        if (res.status) {
        } else {
          Toast("error", "Server Error");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  const returnClassname = (isActive) => {
    if (isActive === true) {
      return "badge bg-success me-2";
    } else {
      return "badge bg-danger me-2";
    }
  };

  const handlePreviousOpen = () => {
    let btn = document.getElementById("currentClose");

    btn.click();
  };
  
  return (
    <div>
      <div className="table-responsive">
        <table className="table table-vcenter">
          <thead>
            <tr>
              {tableHead?.map((item, index) => {
                return (
                  <th
                    className={
                      item === "UID" || item === "Tank" || item === "Farm Name"
                        ? "d-none d-md-table-cell"
                        : ""
                    }
                    key={index}
                  >
                    {item}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {hydrobuildData?.map((item, index) => {
              const Index = (currentPage - 1) * itemsPerPage + index + 1;

              return (
                <tr key={index}>
                  <td>{Index}</td>
                  <td className="d-none d-md-table-cell">
                    <span className={returnClassname(item?.isActive)}></span>
                    {item?.clientProject?.clientName || "N/A"}
                  </td>
                  <td className="d-none d-md-table-cell">
                    {item?.UID || "N/A"}
                  </td>
                  <td className="d-none d-md-table-cell">
                    {item?.Watertankcapacity || "N/A"}
                  </td>
                  {/* <td>{item?.FertiliserSolutiontype || "N/A"}</td> */}
                  <td className="">
                    {item?.agronomyWikiUpdate?.name || "N/A"}
                    <br />
                    <span className="text-secondary">
                      {item?.agronomyWikiUpdate?.articleType}
                    </span>
                  </td>
                  <td>
                    <button
                      className=" d-none d-md-block d-lg-block align-center btn btn-sm px-3 btn-primary pb-1"
                      onClick={() => goToView(item?.UID, item?.isActive)}
                    >
                      Logs
                    </button>
                    <button
                      className="btn btn-sm px-3 btn-primary p-2  d-block d-md-none align-center pb-1"
                      onClick={() => goToView(item?.UID, item?.isActive)}
                    >
                      <FcFile className="fs-1" />
                    </button>
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-sm px-3 btn-primary d-none d-md-block d-lg-block align-center pb-1"
                      data-bs-toggle="modal"
                      data-bs-target="#modal-simple"
                      id="currentClose"
                      onClick={() => setkitId(item?.UID)}
                    >
                      Run Mechanism
                    </button>
                    <button
                      type="button"
                      className="btn  p-2 d-block d-md-none align-center"
                      data-bs-toggle="modal"
                      data-bs-target="#modal-simple"
                      id="currentClose"
                      onClick={() => setkitId(item?.UID)}
                    >
                      <FcServices className="fs-1" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <Formik
        initialValues={HydrobuildRunmachanismInfo}
        // validationSchema={runmachanismSchema}
        onSubmit={handelSubmit}
        enableReinitialize
      >
        {(props) => (
          <Form>
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-lg-12 col-md-12">
                  <div
                    class="modal modal-blur fade"
                    id="modal-simple"
                    tabindex="-1"
                    role="dialog"
                    aria-hidden="true"
                  >
                    <div
                      class="modal-dialog modal-dialog-centered"
                      role="document"
                    >
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title">Run Mechanism</h5>
                          <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div class="modal-body">
                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3">
                              Tank A
                            </label>
                            <div className="w-100 col">
                              <CustomSelect
                                name="tankA"
                                type="text"
                                onChange={(e) => {
                                  props.setFieldValue("tankA", e.target.value);
                                  setSelectedTankAOption(e.target.value);
                                }}
                              >
                                <option value=" ">Select</option>
                                <option value="alwaysOn">Always On</option>
                                <option value="alwaysOff">Always Off</option>
                                <option value="timeSchedule">
                                  Time Scheduled
                                </option>
                                <option value="periodically">
                                  Periodically
                                </option>
                                <option value="smartAi">Smart AI</option>
                              </CustomSelect>
                              {props.touched.tankA && props.errors.tankA && (
                                <p className="text-danger">
                                  {props.errors.tankA}
                                </p>
                              )}
                            </div>
                          </div>

                          {/* Conditional Rendering for Tank A */}
                          {selectedTankAOption === "timeSchedule" && (
                            <div>
                              <div>
                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    Start Date
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="date"
                                        id="tankAStartDate"
                                        name="tankAStartDate"
                                      />
                                      {props.touched.tankAStartDate &&
                                        props.errors.tankAStartDate && (
                                          <p className="text-danger">
                                            {props.errors.tankAStartDate}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    Start Time
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="time"
                                        id="tankAStartTime"
                                        name="tankAStartTime"
                                      />
                                      {props.touched.tankAStartTime &&
                                        props.errors.tankAStartTime && (
                                          <p className="text-danger">
                                            {props.errors.tankAStartTime}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    End Date
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="date"
                                        id="tankAEndDate"
                                        name="tankAEndDate"
                                      />
                                      {props.touched.tankAEndDate &&
                                        props.errors.tankAEndDate && (
                                          <p className="text-danger">
                                            {props.errors.tankAEndDate}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    End Time
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="time"
                                        id="tankAEndTime"
                                        name="tankAEndTime"
                                      />
                                      {props.touched.tankAEndTime &&
                                        props.errors.tankAEndTime && (
                                          <p className="text-danger">
                                            {props.errors.tankAEndTime}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {selectedTankAOption === "periodically" && (
                            <div>
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Start Date
                                </label>
                                <div className="w-100 col">
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="date"
                                      id="tankAStartDate"
                                      name="tankAStartDate"
                                    />
                                    {props.touched.tankAStartDate &&
                                      props.errors.tankAStartDate && (
                                        <p className="text-danger">
                                          {props.errors.tankAStartDate}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Start Time
                                </label>
                                <div className="w-100 col">
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="time"
                                      id="tankAOnTime"
                                      name="tankAOnTime"
                                    />
                                    {props.touched.tankAOnTime &&
                                      props.errors.tankAOnTime && (
                                        <p className="text-danger">
                                          {props.errors.tankAOnTime}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  End Date
                                </label>
                                <div className="w-100 col">
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="date"
                                      id="tankAEndDate"
                                      name="tankAEndDate"
                                    />
                                    {props.touched.tankAEndDate &&
                                      props.errors.tankAEndDate && (
                                        <p className="text-danger">
                                          {props.errors.tankAEndDate}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Off time
                                </label>
                                <div className="w-100 col">
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="time"
                                      id="tankAOffTime"
                                      name="tankAOffTime"
                                    />
                                    {props.touched.tankAOffTime &&
                                      props.errors.tankAOffTime && (
                                        <p className="text-danger">
                                          {props.errors.tankAOffTime}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  On Duration
                                </label>
                                <div className="w-100 col">
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="text"
                                      id="tankAOnDuration"
                                      name="tankAOnDuration"
                                      placeholder="e.g., 30 mins"
                                    />
                                    {props.touched.tankAOnDuration &&
                                      props.errors.tankAOnDuration && (
                                        <p className="text-danger">
                                          {props.errors.tankAOnDuration}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Off Duration:
                                </label>
                                <div className="w-100 col">
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="text"
                                      id="tankAOffDuration"
                                      name="tankAOffDuration"
                                      placeholder="e.g., 30 mins"
                                    />
                                    {props.touched.tankAOffDuration &&
                                      props.errors.tankAOffDuration && (
                                        <p className="text-danger">
                                          {props.errors.tankAOffDuration}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {selectedTankAOption === "smartAi" && (
                            <div>
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Min PPM
                                </label>
                                <div className="w-100 col">
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="text"
                                      id="minAppm"
                                      name="minAppm"
                                    />
                                    {props.touched.minAppm &&
                                      props.errors.minAppm && (
                                        <p className="text-danger">
                                          {props.errors.minAppm}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Max PPM
                                </label>
                                <div className="w-100 col">
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="text"
                                      id="maxAppm"
                                      name="maxAppm"
                                    />
                                    {props.touched.maxAppm &&
                                      props.errors.maxAppm && (
                                        <p className="text-danger">
                                          {props.errors.maxAppm}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Min Ph
                                </label>
                                <div className="w-100 col">
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="text"
                                      id="minAph"
                                      name="minAph"
                                    />
                                    {props.touched.minAph &&
                                      props.errors.minAph && (
                                        <p className="text-danger">
                                          {props.errors.minAph}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Max Ph
                                </label>
                                <div className="w-100 col">
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="text"
                                      id="maxAph"
                                      name="maxAph"
                                    />
                                    {props.touched.maxAph &&
                                      props.errors.maxAph && (
                                        <p className="text-danger">
                                          {props.errors.maxAph}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Tank B */}
                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3">
                              Tank B
                            </label>
                            <div className="w-100 col">
                              <CustomSelect
                                name="tankB"
                                type="text"
                                onChange={(e) => {
                                  props.setFieldValue("tankB", e.target.value);
                                  setSelectedTankBOption(e.target.value);
                                }}
                              >
                                <option value=" ">Select</option>
                                <option value="alwaysOn">Always On</option>
                                <option value="alwaysOff">Always Off</option>
                                <option value="timeSchedule">
                                  Time Scheduled
                                </option>
                                <option value="periodically">
                                  Periodically
                                </option>
                                <option value="smartAi">Smart AI</option>
                              </CustomSelect>
                              {props.touched.tankB && props.errors.tankB && (
                                <p className="text-danger">
                                  {props.errors.tankB}
                                </p>
                              )}
                            </div>
                          </div>

                          {/* Conditional Rendering for Tank B */}
                          {selectedTankBOption === "timeSchedule" && (
                            <div>
                              <div>
                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    Start Date
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="date"
                                        id="tankBStartDate"
                                        name="tankBStartDate"
                                      />
                                      {props.touched.tankBStartDate &&
                                        props.errors.tankBStartDate && (
                                          <p className="text-danger">
                                            {props.errors.tankBStartDate}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    Start Time
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="time"
                                        id="tankBStartTime"
                                        name="tankBStartTime"
                                      />
                                      {props.touched.tankBStartTime &&
                                        props.errors.tankBStartTime && (
                                          <p className="text-danger">
                                            {props.errors.tankBStartTime}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    End Date
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="date"
                                        id="tankBEndDate"
                                        name="tankBEndDate"
                                      />
                                      {props.touched.tankBEndDate &&
                                        props.errors.tankBEndDate && (
                                          <p className="text-danger">
                                            {props.errors.tankBEndDate}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    End Time
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="time"
                                        id="tankBEndTime"
                                        name="tankBEndTime"
                                      />
                                      {props.touched.tankBEndTime &&
                                        props.errors.tankBEndTime && (
                                          <p className="text-danger">
                                            {props.errors.tankBEndTime}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {selectedTankBOption === "periodically" && (
                            <div>
                              <div>
                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    Start Date
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="date"
                                        id="tankBStartDate"
                                        name="tankBStartDate"
                                      />
                                      {props.touched.tankBStartDate &&
                                        props.errors.tankBStartDate && (
                                          <p className="text-danger">
                                            {props.errors.tankBStartDate}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    Start Time
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="time"
                                        id="tankBOnTime"
                                        name="tankBOnTime"
                                      />
                                      {props.touched.tankBOnTime &&
                                        props.errors.tankBOnTime && (
                                          <p className="text-danger">
                                            {props.errors.tankBOnTime}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    End Date
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="date"
                                        id="tankBEndDate"
                                        name="tankBEndDate"
                                      />
                                      {props.touched.tankBEndDate &&
                                        props.errors.tankBEndDate && (
                                          <p className="text-danger">
                                            {props.errors.tankBEndDate}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    Off Time
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="time"
                                        id="tankBOffTime"
                                        name="tankBOffTime"
                                      />
                                      {props.touched.tankBOffTime &&
                                        props.errors.tankBOffTime && (
                                          <p className="text-danger">
                                            {props.errors.tankBOffTime}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    On Duration
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="text"
                                        id="tankBOnDuration"
                                        name="tankBOnDuration"
                                        placeholder="e.g., 30 mins"
                                      />
                                      {props.touched.tankBOnDuration &&
                                        props.errors.tankBOnDuration && (
                                          <p className="text-danger">
                                            {props.errors.tankBOnDuration}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    Off Duration:
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="text"
                                        id="tankBOffDuration"
                                        name="tankBOffDuration"
                                        placeholder="e.g., 15 mins"
                                      />
                                      {props.touched.tankBOffDuration &&
                                        props.errors.tankBOffDuration && (
                                          <p className="text-danger">
                                            {props.errors.tankBOffDuration}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {selectedTankBOption === "smartAi" && (
                            <div>
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Min PPM
                                </label>
                                <div className="w-100 col">
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="text"
                                      id="minBppm"
                                      name="minBppm"
                                    />
                                    {props.touched.minBppm &&
                                      props.errors.minBppm && (
                                        <p className="text-danger">
                                          {props.errors.minBppm}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Max PPM
                                </label>
                                <div className="w-100 col">
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="text"
                                      id="maxBppm"
                                      name="maxBppm"
                                    />
                                    {props.touched.maxBppm &&
                                      props.errors.maxBppm && (
                                        <p className="text-danger">
                                          {props.errors.maxBppm}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Min Ph
                                </label>
                                <div className="w-100 col">
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="text"
                                      id="minBph"
                                      name="minBph"
                                    />
                                    {props.touched.minBph &&
                                      props.errors.minBph && (
                                        <p className="text-danger">
                                          {props.errors.minBph}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Max Ph
                                </label>
                                <div className="w-100 col">
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="text"
                                      id="maxBph"
                                      name="maxBph"
                                    />
                                    {props.touched.maxBph &&
                                      props.errors.maxBph && (
                                        <p className="text-danger">
                                          {props.errors.maxBph}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Tank C */}

                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3">
                              Ph Down Solution
                            </label>
                            <div className="w-100 col">
                              <CustomSelect
                                name="tankPhDown"
                                type="text"
                                onChange={(e) => {
                                  setSelectedPhDownOption(e.target.value);
                                  props.setFieldValue(
                                    "tankPhDown",
                                    e.target.value
                                  );
                                }}
                              >
                                <option value=" ">Select</option>
                                <option value="alwaysOn">Always On</option>
                                <option value="alwaysOff">Always Off</option>
                                <option value="timeSchedule">
                                  Time Scheduled
                                </option>
                                <option value="periodically">
                                  Periodically
                                </option>
                                <option value="smartAi">Smart AI</option>
                              </CustomSelect>
                              {props.touched.tankPhDown &&
                                props.errors.tankPhDown && (
                                  <p className="text-danger">
                                    {props.errors.tankPhDown}
                                  </p>
                                )}
                            </div>
                          </div>

                          {/* Conditional Rendering for Tank C */}
                          {selectedPhDownOption === "timeSchedule" && (
                            <div>
                              <div>
                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    Start Date
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="date"
                                        id="tankPhDownStartDate"
                                        name="tankPhDownStartDate"
                                      />
                                      {props.touched.tankPhDownStartDate &&
                                        props.errors.tankPhDownStartDate && (
                                          <p className="text-danger">
                                            {props.errors.tankPhDownStartDate}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    Start Time
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="time"
                                        id="tankPhDownStartTime"
                                        name="tankPhDownStartTime"
                                      />
                                      {props.touched.tankPhDownStartTime &&
                                        props.errors.tankPhDownStartTime && (
                                          <p className="text-danger">
                                            {props.errors.tankPhDownStartTime}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    End Date
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="date"
                                        id="tankPhDownEndDate"
                                        name="tankPhDownEndDate"
                                      />
                                      {props.touched.tankPhDownEndDate &&
                                        props.errors.tankPhDownEndDate && (
                                          <p className="text-danger">
                                            {props.errors.tankPhDownEndDate}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    End Time
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="time"
                                        id="tankPhDownEndTime"
                                        name="tankPhDownEndTime"
                                      />
                                      {props.touched.tankPhDownEndTime &&
                                        props.errors.tankPhDownEndTime && (
                                          <p className="text-danger">
                                            {props.errors.tankPhDownEndTime}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {selectedPhDownOption === "periodically" && (
                            <div>
                              <div>
                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    Start Date
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="date"
                                        id="tankPhDownStartDate"
                                        name="tankPhDownStartDate"
                                      />
                                      {props.touched.tankPhDownStartDate &&
                                        props.errors.tankPhDownStartDate && (
                                          <p className="text-danger">
                                            {props.errors.tankPhDownStartDate}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    Start Time
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="time"
                                        id="tankPhDownOnTime"
                                        name="tankPhDownOnTime"
                                      />
                                      {props.touched.tankPhDownOnTime &&
                                        props.errors.tankPhDownOnTime && (
                                          <p className="text-danger">
                                            {props.errors.tankPhDownOnTime}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    End Date
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="date"
                                        id="tankPhDownEndDate"
                                        name="tankPhDownEndDate"
                                      />
                                      {props.touched.tankPhDownEndDate &&
                                        props.errors.tankPhDownEndDate && (
                                          <p className="text-danger">
                                            {props.errors.tankPhDownEndDate}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    Off Time
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="time"
                                        id="tankPhDownOffTime"
                                        name="tankPhDownOffTime"
                                      />
                                      {props.touched.tankPhDownOffTime &&
                                        props.errors.tankPhDownOffTime && (
                                          <p className="text-danger">
                                            {props.errors.tankPhDownOffTime}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    On Duration
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="text"
                                        id="tankPhDownOnDuration"
                                        name="tankPhDownOnDuration"
                                        placeholder="e.g., 30 mins"
                                      />
                                      {props.touched.tankPhDownOnDuration &&
                                        props.errors.tankPhDownOnDuration && (
                                          <p className="text-danger">
                                            {props.errors.tankPhDownOnDuration}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="w-25 form-label required col-3">
                                    Off Duration:
                                  </label>
                                  <div className="w-100 col">
                                    <div className="w-100 col">
                                      <CustomInput
                                        type="text"
                                        id="tankPhDownOffDuration"
                                        name="tankPhDownOffDuration"
                                        placeholder="e.g., 15 mins"
                                      />
                                      {props.touched.tankPhDownOffDuration &&
                                        props.errors.tankPhDownOffDuration && (
                                          <p className="text-danger">
                                            {props.errors.tankPhDownOffDuration}
                                          </p>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {selectedPhDownOption === "smartAi" && (
                            <div>
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Min PPM
                                </label>
                                <div className="w-100 col">
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="text"
                                      id="minPhDownppm"
                                      name="minPhDownppm"
                                    />
                                    {props.touched.minPhDownppm &&
                                      props.errors.minPhDownppm && (
                                        <p className="text-danger">
                                          {props.errors.minPhDownppm}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Max PPM
                                </label>
                                <div className="w-100 col">
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="text"
                                      id="maxPhDownppm"
                                      name="maxPhDownppm"
                                    />
                                    {props.touched.maxPhDownppm &&
                                      props.errors.maxPhDownppm && (
                                        <p className="text-danger">
                                          {props.errors.maxPhDownppm}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Min Ph
                                </label>
                                <div className="w-100 col">
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="text"
                                      id="minPhDownph"
                                      name="minPhDownph"
                                    />
                                    {props.touched.minPhDownph &&
                                      props.errors.minPhDownph && (
                                        <p className="text-danger">
                                          {props.errors.minPhDownph}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label required col-3">
                                  Max Ph
                                </label>
                                <div className="w-100 col">
                                  <div className="w-100 col">
                                    <CustomInput
                                      type="text"
                                      id="maxPhDownph"
                                      name="maxPhDownph"
                                    />
                                    {props.touched.maxPhDownph &&
                                      props.errors.maxPhDownph && (
                                        <p className="text-danger">
                                          {props.errors.maxPhDownph}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          <div className="mb-3 row text-end"></div>
                        </div>
                        <div class="modal-footer">
                          <button
                            type="button"
                            className="btn me-auto"
                            data-bs-dismiss="modal"
                            onClick={() => props.resetForm()}
                          >
                            Close
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary"
                            data-bs-toggle="modal"
                            data-bs-target="#modal-dangers"
                          >
                            Calibration
                          </button>
                          <FormSubmitButton
                            data-bs-dismiss="modal"
                            buttonText="Submit"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      <Formik
        initialValues={{ kitId: kitId }}
        // validationSchema={runmachanismSchema}
        onSubmit={handelCalibrationSubmit}
      >
        {(props) => (
          <Form>
            <div
              className="modal modal-blur fade"
              id="modal-dangers"
              tabIndex="-1"
              role="dialog"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <span
                    id="open-modals"
                    data-bs-toggle="modal"
                    data-bs-target="#modal-dangers"
                  ></span>
                  <div class="modal-header">
                    <h5 class="modal-title">Calibration</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={handlePreviousOpen}
                    ></button>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="mb-3">
                        <label class="form-label">
                          Deep your ph Sensor Indistil Calibration Water:{" "}
                        </label>
                        {/* {getName(dropdowndata?.firstName, dropdowndata?.lastName)} */}
                      </div>
                      <div class="mb-3">
                        <label class="form-label">
                          Caliborate ph Sensor now:{" "}
                          <span className="c">Enter Submit Button</span>
                        </label>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Last Calibrated:</label>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <div className="row col-12">
                      <div className="col-6">
                        <button
                          className="btn btn-primary"
                          data-bs-dismiss="modal"
                        >
                          Submit
                        </button>
                      </div>
                      <div className="col-6 text-end">
                        <span
                          className="btn btn-secondary"
                          data-bs-dismiss="modal"
                          onClick={handlePreviousOpen}
                        >
                          Cancel
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
export default Onboardhydrobuildtable;
